import $ from 'jquery';


import './../scss/blocks/block-blog-sample.scss';
import './../scss/pages/_single.scss';

import Swiper from 'swiper';
import { Navigation, Autoplay, Pagination } from 'swiper/modules';

import 'swiper/swiper.scss';  
//import 'swiper/modules/pagination.scss'; 
import 'swiper/modules/navigation.scss'; 


$(document).ready(function() {

  var slides = document.getElementsByClassName("singleposts-slider-wrap");

  for (var i = 0; i < slides.length; i++) {
    //Distribute(slides.item(i));
    var singlepostsswiper = new Swiper(slides.item(i).getElementsByClassName('singleposts-swiper').item(0), {
      modules: [Navigation],
      spaceBetween: 16,
      loop: false,
      slidesPerView: "auto",
      breakpoints: {
        "992": {
          slidesPerView: 3,
          spaceBetween: 24,
        },
        "1200": {
          slidesPerView: 4,
        },
      },
      navigation: {
        nextEl: slides.item(i).getElementsByClassName('singleposts-swiper-button-next').item(0),
        prevEl: slides.item(i).getElementsByClassName('singleposts-swiper-button-prev').item(0),
      },
    });  
  }
  
  

})